// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const PROFILE_REQUEST = 'PROFILE_REQUEST';
const PROFILE_REQUEST_SUCCESS = 'PROFILE_REQUEST_SUCCESS';
const PROFILE_REQUEST_FAILED = 'PROFILE_REQUEST_FAILED';

const PROFILE_FIELD_CHANGE = 'PROFILE_FIELD_CHANGE';
const PROFILE_ERRORS_CHANGE = 'PROFILE_ERRORS_CHANGE';
const RESET_ERRORS_AND_SUCCESS = 'RESET_ERRORS_AND_SUCCESS';

const PROFILE_CHANGE_PASSWORD_REQUEST = 'PROFILE_ERRORS_CHANGE_REQUEST';

const SET_SUCCESS = 'SET_SUCCESS';

const PROFILE_EDIT_REQUEST = 'PROFILE_EDIT_REQUEST';
const PROFILE_EDIT_REQUEST_SUCCESS = 'PROFILE_EDIT_REQUEST_SUCCESS';
const PROFILE_EDIT_REQUEST_FAILED = 'PROFILE_EDIT_REQUEST_FAILED';

const ADDRESS_FIELD_CHANGE = 'ADDRESS_FIELD_CHANGE';
const PAYMENT_FIELD_CHANGE = 'PAYMENT_FIELD_CHANGE';
const PAYPAL_FIELD_CHANGE = 'PAYPAL_FIELD_CHANGE';
const CONFIRM_PAYPAL_FIELD_CHANGE = 'CONFIRM_PAYPAL_FIELD_CHANGE';

const CHANGE_PASSWORD_FIELD = 'CHANGE_PASSWORD_FIELD';
const RESET_PASSWORD_CHANGES = 'RESET_PASSWORD_CHANGES';

const VALIDATE_PAYPAL_EMAIL_REQUEST = 'VALIDATE_PAYPAL_EMAIL_REQUEST';
const VALIDATE_PAYPAL_EMAIL_REQUEST_SUCCESS = 'VALIDATE_PAYPAL_EMAIL_REQUEST_SUCCESS';

const SET_CONFIRM_PAYPAL_NULL = 'SET_CONFIRM_PAYPAL_NULL';
const SET_IS_CHANGE_FIRST_TIME = 'SET_IS_CHANGE_FIRST_TIME';

const VERIFY_PHONE_NUMBER = 'VERIFY_PHONE_NUMBER';
const VERIFY_PHONE_NUMBER_FAILED = 'VERIFY_PHONE_NUMBER_FAILED';

const VERIFY_BANK_ACCOUNT = 'VERIFY_BANK_ACCOUNT';
const VERIFY_BANK_ACCOUNT_FAILED = 'VERIFY_BANK_ACCOUNT_FAILED';

const CHECKOUT_FOR_TRADE_CUSTOMER = 'CHECKOUT_FOR_TRADE_CUSTOMER';

const RESET_ADDRESS = 'RESET_ADDRESS';

export {
  PROFILE_REQUEST,
  PROFILE_REQUEST_SUCCESS,
  PROFILE_REQUEST_FAILED,

  PROFILE_FIELD_CHANGE,
  PROFILE_ERRORS_CHANGE,
  RESET_ERRORS_AND_SUCCESS,

  PROFILE_CHANGE_PASSWORD_REQUEST,

  SET_SUCCESS,

  PROFILE_EDIT_REQUEST,
  PROFILE_EDIT_REQUEST_SUCCESS,
  PROFILE_EDIT_REQUEST_FAILED,

  ADDRESS_FIELD_CHANGE,
  PAYMENT_FIELD_CHANGE,
  PAYPAL_FIELD_CHANGE,
  CONFIRM_PAYPAL_FIELD_CHANGE,

  CHANGE_PASSWORD_FIELD,
  RESET_PASSWORD_CHANGES,

  VALIDATE_PAYPAL_EMAIL_REQUEST,
  VALIDATE_PAYPAL_EMAIL_REQUEST_SUCCESS,

  SET_CONFIRM_PAYPAL_NULL,
  SET_IS_CHANGE_FIRST_TIME,

  VERIFY_PHONE_NUMBER,
  VERIFY_PHONE_NUMBER_FAILED,

  VERIFY_BANK_ACCOUNT,
  VERIFY_BANK_ACCOUNT_FAILED,

  CHECKOUT_FOR_TRADE_CUSTOMER,

  RESET_ADDRESS,
};
